/// <reference types="vite-plugin-svgr/client" />
import { LoadingMessage } from './components/LoadingMessage';

export default function LoadingElement() {
  return <LoadingMessage />;
}
